
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class MessageDialog extends Vue {
  @Prop({}) exam!: any;
  title = "新建短信通知模板";

  created() {
    //
  }
  mounted() {
    const a = this.exam;
    console.log(a);
  }

  ok() {
    this.$emit("ok", this.exam.templateName);
    //
  }

  //关闭
  close() {
    this.$emit("cancelMessage", false);
  }
}
